export const CLIENT_APP_CLIENT_USERS_MY = 'CLIENT_APP_CLIENT_USERS_MY';
export const CLIENT_APP_CLIENT_USER_INFO = 'CLIENT_APP_CLIENT_USER_INFO';

export const CLIENT_APP_COUNTRIES = 'CLIENT_APP_COUNTRIES';
export const CLIENT_APP_WAREHOUSES = 'CLIENT_APP_WAREHOUSES';

export const CLIENT_ORDERS_GET_MANY = 'CLIENT_ORDERS_GET_MANY';
export const CLIENT_ORDER_CARGOES_GET_MANY = 'CLIENT_ORDER_CARGOES_GET_MANY';

export const CLIENT_CONTACTS_GET_MANY = 'CLIENT_CONTACTS_GET_MANY';

export const CLIENT_CARGO_DOCUMENTS_GET_MANY = 'CLIENT_CARGO_DOCUMENTS_GET_MANY';
export const CLIENT_ORDER_INVOICE_DOCUMENTS_GET_MANY = 'CLIENT_ORDER_INVOICE_DOCUMENTS_GET_MANY';

export const CLIENT_CARGO_GEO = 'CLIENT_CARGO_GEO';
